// /* eslint-disable no-unused-expressions */

// import { Table, Input } from "antd";
// import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
// import { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// import moment from "moment";

// const Holidays = () => {
//   // const [holidaysData, setHolidaysData] = useState([
//   //   {
//   //     ID: 1,
//   //     TITLE: "Project 1",
//   //     HOLIDAY_DATE: moment().format("YYYY-MM-DD"),
//   //   },
//   //   {
//   //     ID: 2,
//   //     TITLE: "Project 2",
//   //     HOLIDAY_DATE: moment().add(1, "days").format("YYYY-MM-DD"), // Adds one day to current date
//   //   },
//   // ]); // Initialize holidays data state

//   const [holidaysData, setHolidaysData] = useState([
//     {
//       ID: 1,
//       TITLE: "Project 1",
//       HOLIDAY_DATE: moment().subtract(2, "days").format("YYYY-MM-DD"), // 1 day before today
//     },
//     {
//       ID: 2,
//       TITLE: "Project 2",
//       HOLIDAY_DATE: moment().subtract(1, "days").format("YYYY-MM-DD"), // 2 days before today
//     },
//   ]);

//   const [title, setTitle] = useState("");
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedRecord, setSelectedRecord] = useState(null); // Track selected record for deletion
//   const navigate = useNavigate(); // Initialize useNavigate hook

//   const token = localStorage.getItem("LogIn_Token");

//   // Handle submission of new project/holiday entry
//   const handleSubmit = () => {
//     if (title) {
//       const newEntry = {
//         ID: holidaysData.length + 1, // Incremental ID for new entry
//         TITLE: title,
//         HOLIDAY_DATE: moment().format("YYYY-MM-DD"), // Automatically use today's date
//       };

//       // Add new entry to holidaysData state
//       setHolidaysData((prevData) => [...prevData, newEntry]);

//       // Clear form fields and close modal
//       setTitle("");
//       setIsModalVisible(false);
//     } else {
//       alert("Please enter a valid project name.");
//     }
//   };

//   // Handle deletion of a holiday/project entry
//   const handleDelete = () => {
//     if (selectedRecord) {
//       // Remove selected record from holidaysData
//       console.log("delete");
//       setHolidaysData((prevData) =>
//         prevData.filter((item) => item.ID !== selectedRecord.ID)
//       );
//     }
//     console.log("delete2");

//     setSelectedRecord(null); // Reset selected record after deletion
//     console.log("delete3");
//   };

//   const handleOpenClick = () => {
//     navigate("/cluster-creations"); // Navigate to the dynamic route with project ID
//   };

//   // Define columns for the table
//   const columns = [
//     {
//       title: "Project Name",
//       dataIndex: "TITLE",
//       render: (text) => <span>{text}</span>,
//       sorter: (a, b) => a.ID - b.ID,
//     },
//     {
//       title: "Date Created",
//       dataIndex: "HOLIDAY_DATE",
//       render: (text) => <span>{moment(text).format("YYYY-MM-DD")}</span>,
//       sorter: (a, b) => new Date(a.HOLIDAY_DATE) - new Date(b.HOLIDAY_DATE),
//     },
//     {
//       title: "Open",
//       dataIndex: "chk",
//       render: (text, record) => (
//         // {}
//         <>
//           <span>{text}</span>
//           <button
//             type="button"
//             className="btn btn-success me-2"
//             onClick={() => handleOpenClick()}
//           >
//             Open
//           </button>
//         </>
//       ),
//     },
//     {
//       title: "Delete",
//       dataIndex: "Delete",
//       render: (text, record) => (
//         <span>
//           <Link
//             to="#"
//             className="btn dropdown-item rounded-2"
//             data-bs-toggle="modal"
//             data-bs-target={"#delete"} // Link to delete modal
//             onClick={() => setSelectedRecord(record)} // Select record to be deleted
//           >
//             <i
//               className="fa fa-trash"
//               style={{ cursor: "pointer", color: "red" }}
//             />
//           </Link>
//         </span>
//       ),
//     },
//   ];

//   // Handle search query change
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Filter data based on search query
//   const filteredData = holidaysData.filter((item) =>
//     Object.values(item).some((value) =>
//       String(value).toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   );

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           <Breadcrumbs
//             maintitle="Monthly Consumption Usage Profile"
//             title="Dashboard"
//             modal="#add_holiday"
//             name="Add New Project"
//             onClick={() => setIsModalVisible(true)} // Show modal on clicking Add New Project
//           />

//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <Input
//                   placeholder="Search Project"
//                   value={searchQuery}
//                   onChange={handleSearchChange}
//                   style={{ marginBottom: "20px", height: "45px" }}
//                 />
//                 <Table
//                   columns={columns}
//                   dataSource={filteredData.length > 0 ? filteredData : []}
//                   className="table-striped"
//                   rowKey={(record) => record.ID}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add Holiday Modal */}
//       <AddHoliday
//         setTitle={setTitle}
//         handleSubmit={handleSubmit}
//         isModalVisible={isModalVisible}
//         setIsModalVisible={setIsModalVisible} // Close modal after submission
//       />

//       {/* Delete Modal */}
//       <DeleteModal Name="delete" onDelete={handleDelete} />
//     </>
//   );
// };

// export default Holidays;

import { Table, Input } from "antd";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import Breadcrumbs from "../../../components/Breadcrumbs";
import moment from "moment";

const Holidays = () => {
  // const [holidaysData, setHolidaysData] = useState([
  //   {
  //     ID: 1,
  //     TITLE: "Project 1",
  //     HOLIDAY_DATE: moment().format("YYYY-MM-DD"),
  //   },
  //   {
  //     ID: 2,
  //     TITLE: "Project 2",
  //     HOLIDAY_DATE: moment().add(1, "days").format("YYYY-MM-DD"), // Adds one day to current date
  //   },
  // ]); // Initialize holidays data state

  const [holidaysData, setHolidaysData] = useState([
    {
      ID: 1,
      TITLE: "Project 1",
      SHOWDATA:true,
      HOLIDAY_DATE: moment().subtract(2, "days").format("YYYY-MM-DD"), // 1 day before today
    },
    {
      ID: 2,
      TITLE: "Project 2",
      SHOWDATA:true,
      HOLIDAY_DATE: moment().subtract(1, "days").format("YYYY-MM-DD"), // 2 days before today
    },
  ]);

  const [title, setTitle] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const navigate = useNavigate();

  // Fetch holidays from localStorage on component mount
  useEffect(() => {
    const storedHolidays = localStorage.getItem("holidaysData");
    if (storedHolidays) {
      setHolidaysData(JSON.parse(storedHolidays));
    } else {
      // Initialize with default data if localStorage is empty
      const initialData = [
        {
          ID: 1,
          TITLE: "Project 1",
          HOLIDAY_DATE: moment().subtract(2, "days").format("YYYY-MM-DD"),
        },
        {
          ID: 2,
          TITLE: "Project 2",
          HOLIDAY_DATE: moment().subtract(1, "days").format("YYYY-MM-DD"),
        },
      ];
      localStorage.setItem("holidaysData", JSON.stringify(initialData));
      setHolidaysData(initialData);
    }
  }, []);

  // Handle submission of new project/holiday entry
  const handleSubmit = () => {
    if (title) {
      const newEntry = {
        ID: holidaysData.length + 1,
        TITLE: title,
        HOLIDAY_DATE: moment().format("YYYY-MM-DD"),
      };

      const updatedHolidays = [...holidaysData, newEntry];
      setHolidaysData(updatedHolidays);
      localStorage.setItem("holidaysData", JSON.stringify(updatedHolidays));

      setTitle("");
      setIsModalVisible(false);
    } else {
      alert("Please enter a valid project name.");
    }
  };

  // Handle deletion of a holiday/project entry
  const handleDelete = () => {
    if (selectedRecord) {
      const updatedHolidays = [...holidaysData];
      const index = updatedHolidays.findIndex(
        (item) => item.ID === selectedRecord.ID
      );

      if (index > -1) {
        updatedHolidays.splice(index, 1); // Remove the selected record
        setHolidaysData(updatedHolidays); // Update state
        localStorage.setItem("holidaysData", JSON.stringify(updatedHolidays)); // Update localStorage
      }

      setSelectedRecord(null);
    }
  };

  const handleOpenClick = () => {
    navigate("/cluster-creations"); // Navigate to the dynamic route with project ID
  };

  const columns = [
    {
      title: "Project Name",
      dataIndex: "TITLE",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.ID - b.ID,
    },
    {
      title: "Date Created",
      dataIndex: "HOLIDAY_DATE",
      render: (text) => <span>{moment(text).format("YYYY-MM-DD")}</span>,
      sorter: (a, b) => new Date(a.HOLIDAY_DATE) - new Date(b.HOLIDAY_DATE),
    },
    {
      title: "Open",
      dataIndex: "chk",
      render: (text,record) =>
         (
        <>
        {console.log("recordrecord",record)}
          <span>{text}</span>
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={() => handleOpenClick(record)}
          >
            Open
          </button>
        </>
      ),
    },
    {
      title: "Delete",
      dataIndex: "Delete",
      render: (text, record) => (
        <span>
          <Link
            to="#"
            className="btn dropdown-item rounded-2"
            data-bs-toggle="modal"
            data-bs-target={"#delete"} // Link to delete modal
            onClick={() => setSelectedRecord(record)} // Select record to be deleted
          >
            <i
              className="fa fa-trash"
              style={{ cursor: "pointer", color: "red" }}
            />
          </Link>
        </span>
      ),
    },
  ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = holidaysData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Monthly Consumption Usage Profile"
            title="Dashboard"
            modal="#add_holiday"
            name="Add New Project"
            onClick={() => setIsModalVisible(true)}
          />

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Input
                  placeholder="Search Project"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  style={{ marginBottom: "20px", height: "45px" }}
                />
                <Table
                  columns={columns}
                  dataSource={filteredData.length > 0 ? filteredData : []}
                  className="table-striped"
                  rowKey={(record) => record.ID}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Holiday Modal */}
      <AddHoliday
        setTitle={setTitle}
        handleSubmit={handleSubmit}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />

      {/* Delete Modal */}
      <DeleteModal Name="delete" onDelete={handleDelete} />
    </>
  );
};

export default Holidays;
